import { apiJson } from './api'

export interface UserNotificationItem {
  id: string
  userId: string
  title: string
  message: string
  category: string
  actionUrl: string | null
  isRead: boolean
  readAt: string | null
  metadata: Record<string, unknown> | null
  createdAt: string
}

export interface UserNotificationsListResponse {
  items: UserNotificationItem[]
  unreadCount: number
  total: number
  limit: number
  offset: number
}

export async function getUserNotifications(
  limit = 20,
  offset = 0,
  unreadOnly = false,
): Promise<UserNotificationsListResponse> {
  const query = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    unreadOnly: String(unreadOnly),
  })
  return apiJson<UserNotificationsListResponse>(
    `/user-notifications?${query.toString()}`,
    {},
    'Gagal memuat notifikasi',
  )
}

export async function markUserNotificationAsRead(id: string): Promise<{ success: boolean }> {
  return apiJson<{ success: boolean }>(
    `/user-notifications/${id}/read`,
    {
      method: 'PATCH',
    },
    'Gagal menandai notifikasi sebagai dibaca',
  )
}

export async function markAllUserNotificationsAsRead(): Promise<{ success: boolean; updatedCount: number }> {
  return apiJson<{ success: boolean; updatedCount: number }>(
    '/user-notifications/read-all',
    {
      method: 'POST',
    },
    'Gagal menandai semua notifikasi sebagai dibaca',
  )
}
